module.exports = __webpack_public_path__ + "static/media/cnx.4d3c68eb.svg";